// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const UnholdList = lazy(() => import('pages/holdUnhold/unhold/unholdList'));

const UnholdRoute = (
  <Route path={routeName.release}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.RELEASE_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <UnholdList />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default UnholdRoute;
